const normalizeDate = (date, { ignoreTime = false } = {}) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return null;
  if (!ignoreTime) return date;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

export const isDateOutOfRange = (date, minDate, maxDate, options = {}) => {
  const normalized = normalizeDate(date, options);
  if (!normalized) return false;

  const min = normalizeDate(minDate, options);
  const max = normalizeDate(maxDate, options);

  if (min && normalized < min) return true;
  if (max && normalized > max) return true;
  return false;
};

export const parseDateInput = (value) => {
  if (!value) return null;
  const raw = value.toString().trim();
  if (!raw) return null;

  const isoMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
  if (isoMatch) {
    const [, y, m, d] = isoMatch;
    const date = new Date(Number(y), Number(m) - 1, Number(d));
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const slashMatch = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(raw);
  if (slashMatch) {
    const [, d, m, y] = slashMatch;
    const date = new Date(Number(y), Number(m) - 1, Number(d));
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const dashMatch = /^(\d{2})-(\d{2})-(\d{4})$/.exec(raw);
  if (dashMatch) {
    const [, d, m, y] = dashMatch;
    const date = new Date(Number(y), Number(m) - 1, Number(d));
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const blockManualDateInput = (event) => {
  if (!event) return;
  const allowedKeys = new Set([
    "Tab",
    "Shift",
    "Escape",
    "Enter",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
    "Home",
    "End",
  ]);

  if (allowedKeys.has(event.key)) return;
  event.preventDefault();
};

export const blockDatePaste = (event) => {
  if (!event) return;
  event.preventDefault();
};
